/**
 * Finds the first key an object carries that its allowed list does not, and says so in the message
 * the caller gets back. Returns an empty string when every key is allowed.
 */

const describeUnknownKey = ({ value, allowed, where }) => {
  const found = Object.keys(value).find((key) => !allowed.includes(key));

  return found ? `${where} does not accept "${found}". Allowed: ${allowed.join(', ')}.` : '';
};

export default describeUnknownKey;
